import React from "react";

export default function CreatedForms() {
  return <div>CreatedForms</div>;
}
